import { render, staticRenderFns } from "./GroupStatisticTemplateView.vue?vue&type=template&id=425d8855"
import script from "./GroupStatisticTemplateView.vue?vue&type=script&lang=js"
export * from "./GroupStatisticTemplateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports